module.exports = __webpack_public_path__ + "static/enhanced-straight-51dfe7889574b3b7b26b438af260133c.svg";